import { http } from "../index";
import Config from "../config/config";

const FooterNews = () => {
  return http.get({
    url: Config.News.Footer.replace("{seconds}", Date.now().toString()),
  });
};
const getNewsFromBanners = () => {
  return http.get({
    url: Config.News.getNewsFromBanners,
  });
};

const getGameLobbyPromos = () => {
  return http.get({
    url: Config.News.getGameLobbyPromos,
  });
};


export default {
  FooterNews,
  getNewsFromBanners,
  getGameLobbyPromos
};
